import { trace } from 'rytm-helpers'
import LocomotiveScroll from 'locomotive-scroll'
import { updateGloAnimate } from './globtrak/glo-animate'
import { affixOnLocomotiveScroll } from './shared/affix-fafix'
import { updateHeaderOnLocomotiveScroll } from './shared/header-scroll'
const imagesLoaded = require("imagesloaded");

let scroll, scrollContainer
let subscribers = []

export const initLocomotiveScroll = () => {
  trace("init locomotive scroll")
  scrollContainer = document.querySelector('[data-scroll-container]')

  if (scrollContainer) {
    scroll = new LocomotiveScroll({
      el: scrollContainer,
      smooth: true,
      lerp: .16,
      multiplier: 1,
    })
    scroll.on('scroll', onLocomotiveScroll)
  }
  imagesLoaded(scrollContainer, { background: true }, function () {
    scroll.update()
  })
}

const onLocomotiveScroll = (args) => {
  affixOnLocomotiveScroll(args.scroll.y)
  updateHeaderOnLocomotiveScroll(args.scroll.y)
  updateGloAnimate(args)
  subscribers.forEach((obj) => {
    obj.method(args)
  })
}

export const subscribeScroll = (id, method) => {
  subscribers.push({id, method})
  console.log(subscribers)
}
export const unsubscribeScroll = (id) => {
  subscribers = subscribers.filter(obj => obj.id != id)
  console.log(subscribers)
}

export const updateLocomotiveScroll = () => {
  if (scroll) {
    scroll.update()
  }
}
export const destroyLocomotiveScroll = () => {
  if (scroll) {
    scroll.destroy()
  }
}